var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hidden md:block bg-transparent font-semibold py-2 px-4 rounded",class:_vm.connectionStateStyling,on:{"click":_vm.connect}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }